import React from 'react';
import { useQuery } from '@apollo/client';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { cobaltIntelligenceApi, HasAccessToCobaltReportResponse } from '../api';

interface CobaltIntelligenceGuardProps {
  children: React.ReactNode;
}

export const CobaltIntelligenceGuard = ({ children }: CobaltIntelligenceGuardProps) => {
  const { loading, data, error } = useQuery<HasAccessToCobaltReportResponse>(
    cobaltIntelligenceApi.hasAccessToCobaltReport
  );

  const hasAccess = !error && Boolean(data?.cobaltIntelligence?.result?.entity);

  return (
    <RenderWithFallback isLoading={loading}>
      <RenderWithCondition condition={hasAccess}>{children}</RenderWithCondition>
    </RenderWithFallback>
  );
};
